import SnippetTemplateMessage from './SnippetTemplateMessage';
export default SnippetTemplateMessage;